import React from "react";
import styles from "./adLocation.scss";

const AdLocation = ({ value }) => (
  <div className={styles.location}>{value || ""}</div>
);

export default AdLocation;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdLocation/AdLocation.tsx